import { defineComponent, h, computed, type PropType } from 'vue';
import { DateTime } from 'luxon';

type DateValue = number | string | Date;

export const DateCell = defineComponent({
  name: 'DateCell',
  props: {
    date: {
      type: [Number, String, Date] as PropType<DateValue>,
      required: true,
    },
    showTime: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { attrs }) {
    const date = computed<string>(() => {
      if (!props.date) {
        return '';
      }

      const dateTime = DateTime.fromJSDate(new Date(props.date as DateValue));

      if (!props.showTime) {
        return dateTime.toFormat('MMM dd, yyyy');
      }

      return `${dateTime.toFormat('MMM dd, yyyy, hh:mm')} ${dateTime.toFormat('a').toLowerCase()}`;
    });

    return () =>
      h(
        'span',
        {
          ...attrs,
          class: ['whitespace-nowrap', { ...(attrs.class as any) }],
        },
        date?.value || '-',
      );
  },
});
